import { outter_post , file_post} from 'common/js/axios-helper';
import { APPApi } from "./constant/UrlMapper";

const host = '8885';
const host2 = '8883';
const host3 = '8880';


const tatTatSourceMaterialList = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialList, data, host3);
};

const tatTatSourceMaterialAdd = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialAdd, data, host3);
};

const tatTatSourceMaterialEdit = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialEdit, data, host3);
};

const tatTatSourceMaterialDel = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialDel, data, host3);
};

const tatTatSourceMaterialUdp = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialUdp, data, host3);
};

const tatTatSourceMaterialType = (data) => {
    return outter_post(APPApi.TatTatSourceMaterialType, data, host3);
};

const uploadImg = (data) => {
    return file_post("/picture/upload", data, host2);
};
const list = (data) => {
    return outter_post(APPApi.List, data, host2);
};

const detail = (data) => {
    return outter_post(APPApi.Detail, data, host2);
};

const delInfo = (data) => {
    return outter_post(APPApi.Delete, data, host2);
};

const upload = (data) => {
    return outter_post(APPApi.Upload, data, host2);
};

const add = (data) => {
    return outter_post(APPApi.Add, data, host2);
};

const edit = (data) => {
    return outter_post(APPApi.Edit, data, host2);
};

const detailList = (data) => {
    return outter_post(APPApi.DetailList, data, host2);
};

const sendList = (data) => {
    return outter_post(APPApi.SendList, data, host);
};

const getMemLevel = (data) => {
    return outter_post(APPApi.GetMemLevel, data, host);
};

const sendsms = (data) => {
    return outter_post(APPApi.Sendsms, data, host);
};

const getStatisCount = (data) => {
    return outter_post(APPApi.GetStatisCount, data, host);
};

const getList = (data) => {
    return outter_post(APPApi.GetList, data, host);
};

const getVersionNum = (data) => {
    return outter_post(APPApi.GetVersionNum, data, host2);
};

const sysMsgList = (data) => {
    return outter_post(APPApi.SysMsgList, data, host3);
};

const sysMsgCreate = (data) => {
    return outter_post(APPApi.SysMsgCreate, data, host3);
};

const sysMsgDelete = (data) => {
    return outter_post(APPApi.SysMsgDelete, data, host3);
};

const sysMsgUpdate = (data) => {
    return outter_post(APPApi.SysMsgUpdate, data, host3);
};

const sysMsgEnable = (data) => {
    return outter_post(APPApi.SysMsgEnable, data, host3);
};

const loadApp = (data) => {
    return outter_post(APPApi.LoadApp, data, host2);
};

const tatMessageSettingAdd = (data) => {
    return outter_post(APPApi.TatMessageSettingAdd, data, host3);
};

const tatMessageSettingEdit = (data) => {
    return outter_post(APPApi.TatMessageSettingEdit, data, host3);
};

const tatMessageSettingList = (data) => {
    return outter_post(APPApi.TatMessageSettingList, data, host3);
};

const tatMessageSettingDel = (data) => {
    return outter_post(APPApi.TatMessageSettingDel, data, host3);
};

const customconfigurationList = (data) => {
    return outter_post(APPApi.CustomconfigurationList, data, host);
};
const customconfigurationEdit = (data) => {
    return outter_post(APPApi.CustomconfigurationEdit, data, host);
};
const customconfigurationInsert = (data) => {
    return outter_post(APPApi.CustomconfigurationInsert, data, host);
};
const customconfigurationDel = (data) => {
    return outter_post(APPApi.CustomconfigurationDel, data, host);
};
const bankNameYz = (data) => {
    return outter_post(APPApi.BankNameYz, data, host);
};
const status = (data) => {
    return outter_post(APPApi.Status, data, host);
};

// 操作视频
const operationvideoList = (data) => {
    return outter_post(APPApi.OperationVideoList, data, host3);
};
const operationvideoAdd = (data) => {
    return outter_post(APPApi.OperationVideoAdd, data, host3);
};
const operationvideoEdit = (data) => {
    return outter_post(APPApi.OperationVideoEdit, data, host3);
};
const operationvideoDetail = (data) => {
    return outter_post(APPApi.OperationVideoDetail, data, host3);
};
const operationvideoUdp = (data) => {
    return outter_post(APPApi.OperationVideoUdp, data, host3);
};
const operationvideoDel = (data) => {
    return outter_post(APPApi.OperationVideoDel, data, host3);
};

//app公告
const tatActivityMsg = (data) => {
    return outter_post(APPApi.TatActivityMsg, data, host3);
};

const tatActivityMsgDel = (data) => {
    return outter_post(APPApi.TatActivityMsgDel, data, host3);
};

const tatActivityMsgUdp = (data) => {
    return outter_post(APPApi.TatActivityMsgUdp, data, host3);
};

const tatActivityMsgAdd = (data) => {
    return outter_post(APPApi.TatActivityMsgAdd, data, host3);
};

const tatActivityMsgUpd = (data) => {
    return outter_post(APPApi.TatActivityMsgUpd, data, host3);
};

//帮助中心
const helpcenterList = (data) => {
    return outter_post(APPApi.HelpCenterList, data, host3);
};
const helpcenterEdit = (data) => {
    return outter_post(APPApi.HelpCenterEdit, data, host3);
};
const helpcenterInsert = (data) => {
    return outter_post(APPApi.HelpCenterInsert, data, host3);
};
const helpcenterDel = (data) => {
    return outter_post(APPApi.HelpCenterDel, data, host3);
};
const helpcenterStatus = (data) => {
    return outter_post(APPApi.HelpCenterStatus, data, host3);
};

// 轮播配置
const bannerList = (data) => {
    return outter_post(APPApi.BannerList, data,host3);
}
const bannerInsert = (data) => {
    return outter_post(APPApi.BannerInsert, data,host3);
}
const bannerEdit = (data) => {
    return outter_post(APPApi.BannerEdit, data,host3);
}
const bannerDel = (data) => {
    return outter_post(APPApi.BannerDel, data,host3);
}
const bannerStatus = (data) => {
    return outter_post(APPApi.BannerStatus, data,host3);
}


const rbannerList = (data) => {
    return outter_post(APPApi.RBannerList, data,host3);
}
const rbannerInsert = (data) => {
    return outter_post(APPApi.RBannerInsert, data,host3);
}
const rbannerEdit = (data) => {
    return outter_post(APPApi.RBannerEdit, data,host3);
}
const rbannerDel = (data) => {
    return outter_post(APPApi.RBannerDel, data,host3);
}
const rbannerStatus = (data) => {
    return outter_post(APPApi.RBannerStatus, data,host3);
}


// 轮盘抽奖
const roulettelList = (data) => {
    return outter_post(APPApi.RoulettelList, data, '9000');
};
const roulettelAdd = (data) => {
    return outter_post(APPApi.RoulettelAdd, data, '9000');
};
const roulettelEdit = (data) => {
    return outter_post(APPApi.RoulettelEdit, data, '9000');
};
const roulettelDel = (data) => {
    return outter_post(APPApi.RoulettelDel, data, '9000');
};
const roulettelStatus = (data) => {
    return outter_post(APPApi.RoulettelStatus, data, '9000');
};
const roulettelListFalse = (data) => {
    return outter_post(APPApi.RoulettelListFalse, data, '9000');
};
const roulettelAddFalse = (data) => {
    return outter_post(APPApi.RoulettelAddFalse, data, '9000');
};
const roulettelEditFalse = (data) => {
    return outter_post(APPApi.RoulettelEditFalse, data, '9000');
};
const roulettelDelFalse = (data) => {
    return outter_post(APPApi.RoulettelDelFalse, data, '9000');
};
const roulettelStatusFalse = (data) => {
    return outter_post(APPApi.RoulettelStatusFalse, data, '9000');
};

const configList = (data) => {
    return outter_post(APPApi.ConfigList, data, '9000');
};
const configAdd = (data) => {
    return outter_post(APPApi.ConfigAdd, data, '9000');
};
const configEdit = (data) => {
    return outter_post(APPApi.ConfigEdit, data, '9000');
};
const configDel = (data) => {
    return outter_post(APPApi.ConfigDel, data, '9000');
};

const configListFalse = (data) => {
    return outter_post(APPApi.ConfigListFalse, data, '9000');
};
const configAddFalse = (data) => {
    return outter_post(APPApi.ConfigAddFalse, data, '9000');
};
const configEditFalse = (data) => {
    return outter_post(APPApi.ConfigEditFalse, data, '9000');
};
const configDelFalse = (data) => {
    return outter_post(APPApi.ConfigDelFalse, data, '9000');
};


// 用户抽奖明细
const userLucklist = (data) => {
    return outter_post(APPApi.UserLucklist, data, '9000');
};
const userLuckadd = (data) => {
    return outter_post(APPApi.UserLuckadd, data, '9000');
};
const userLuckedit = (data) => {
    return outter_post(APPApi.UserLuckedit, data, '9000');
};
const userLuckdel = (data) => {
    return outter_post(APPApi.UserLuckdel, data, '9000');
};
const userLuck = (data) => {
    return outter_post(APPApi.UserLuck, data, '9000');
};
const userLotteryMovie = (data) => {
    return outter_post(APPApi.UserLotteryMovie, data, '9000');
};

//风采展示
const styledisplayList = (data) => {
    return outter_post(APPApi.StyleDisplayList, data, host3);
};
const styledisplayEdit = (data) => {
    return outter_post(APPApi.StyleDisplayEdit, data, host3);
};
const styledisplayInsert = (data) => {
    return outter_post(APPApi.StyleDisplayInsert, data, host3);
};
const styledisplayDel = (data) => {
    return outter_post(APPApi.StyleDisplayDel, data, host3);
};
const styledisplayStatus = (data) => {
    return outter_post(APPApi.StyleDisplayStatus, data, host3);
};

//激活版管理相关接口
const rankingmanageUpdate = (data) => {
    return outter_post(APPApi.RankIngManageUpdate, data, host);
};
const rankingmanageList = (data) => {
    return outter_post(APPApi.RankIngManageList, data, host);
};

const monthlylistList = (data) => {   //月榜
    return outter_post(APPApi.MonthlyListList, data, host);
};

const weeklistList = (data) => {   //周榜
    return outter_post(APPApi.WeekList, data, host);
};

const weeklistNum = (data) => {  //周数
    return outter_post(APPApi.WeekNum, data, host);
};
const integralSource = (data) => {      //积分来源
    return outter_post(APPApi.IntegralSource, data, host);
};
const integralType = (data) => {    //排行榜类型
    return outter_post(APPApi.IntegralType, data, host);
};

const integrallistList = (data) => {  //积分明细查询
    return outter_post(APPApi.IntegrallistList, data, host);
};

const rewardlistList = (data) => {  //奖励明细
    return outter_post(APPApi.RewardlistList, data, host);
};
const rewardlistSH = (data) => {
    return outter_post(APPApi.RewardlistSH, data, host);
};

//新激活版管理相关接口
const newrankingmanageUpdate = (data) => {
    return outter_post(APPApi.NewRankIngManageUpdate, data, host);
};
const newrankingmanageList = (data) => {
    return outter_post(APPApi.NewRankIngManageList, data, host);
};
const newrankingmanageStatus = (data) => {
    return outter_post(APPApi.NewRankIngManageStatus, data, host);
};
const newrankingmanageDel = (data) => {
    return outter_post(APPApi.NewRankIngManageDel, data, host);
};
const newrankingmanagegettype = (data) => {
    return outter_post(APPApi.NewRankIngManagegetType, data, host);
};
const newrankingmanageDetail = (data) => {
    return outter_post(APPApi.NewRankIngManageDetail, data, host);
};

const newmonthlylistList = (data) => {   //月榜
    return outter_post(APPApi.NewMonthlyListList, data, host);
};
const newmonthlylistEdit = (data) => {   //月榜
    return outter_post(APPApi.NewMonthlyListEdit, data, host);
};

const newintegrallistList = (data) => {  //积分明细查询
    return outter_post(APPApi.NewIntegrallistList, data, host);
};

const newrewardlistList = (data) => {  //奖励明细
    return outter_post(APPApi.NewRewardlistList, data, host);
};
const newrewardlistSH = (data) => {
    return outter_post(APPApi.NewRewardlistSH, data, host);
};

// 商户等级管理
const merchantlevelmanageList = (data) => {
    return outter_post(APPApi.MerchantLevelManageList, data, "9000");
};
const merchantlevelmanageEdit = (data) => {
    return outter_post(APPApi.MerchantLevelManageEdit, data, "9000");
};

//商户升级明细
const merchantupgradeinfoList = (data) => {
    return outter_post(APPApi.MerchantUpgradeInfoList, data, "9000");
};




export default {
    tatTatSourceMaterialList,
    tatTatSourceMaterialAdd,
    tatTatSourceMaterialEdit,
    tatTatSourceMaterialDel,
    tatTatSourceMaterialUdp,
    tatTatSourceMaterialType,

    uploadImg,
    list,
    detail,
    delInfo,
    upload,
    add,
    edit,
    detailList,
    sendList,
    getMemLevel,
    sendsms,
    getStatisCount,
    getList,
    sysMsgList,
    sysMsgCreate,
    sysMsgDelete,
    sysMsgUpdate,
    sysMsgEnable,
    loadApp,
    getVersionNum,
    tatMessageSettingAdd,
    tatMessageSettingEdit,
    tatMessageSettingList,
    tatMessageSettingDel,

    customconfigurationList,
    customconfigurationEdit,
    customconfigurationInsert,
    customconfigurationDel,
    bankNameYz,
    status,

    operationvideoList,
    operationvideoAdd,
    operationvideoEdit,
    operationvideoDetail,
    operationvideoUdp,
    operationvideoDel,

    tatActivityMsg,
    tatActivityMsgDel,
    tatActivityMsgUdp,
    tatActivityMsgAdd,
    tatActivityMsgUpd,

    helpcenterList,
    helpcenterEdit,
    helpcenterInsert,
    helpcenterDel,
    helpcenterStatus,

    bannerList,
    bannerInsert,
    bannerEdit,
    bannerDel,
    bannerStatus,

    rbannerList,
    rbannerInsert,
    rbannerEdit,
    rbannerDel,
    rbannerStatus,

    roulettelList,
    roulettelAdd,
    roulettelEdit,
    roulettelDel,
    roulettelStatus,

    roulettelListFalse,
    roulettelAddFalse,
    roulettelEditFalse,
    roulettelDelFalse,
    roulettelStatusFalse,

    configList,
    configAdd,
    configEdit,
    configDel,

    configListFalse,
    configAddFalse,
    configEditFalse,
    configDelFalse,

    userLucklist,
    userLuckadd,
    userLuckedit,
    userLuckdel,
    userLuck,
    userLotteryMovie,

    styledisplayList,
    styledisplayEdit,
    styledisplayInsert,
    styledisplayDel,
    styledisplayStatus,

    rankingmanageUpdate,
    rankingmanageList,

    monthlylistList,

    weeklistList,

    weeklistNum,
    integralSource,
    integralType,

    integrallistList,

    rewardlistList,
    rewardlistSH,

    newrewardlistList,
    newrewardlistSH,

    newrankingmanageUpdate,
    newrankingmanageList,
    newrankingmanageStatus,
    newrankingmanageDel,
    newrankingmanagegettype,
    newrankingmanageDetail,

    newmonthlylistList,
    newmonthlylistEdit,

    newintegrallistList,

    newrewardlistList,
    newrewardlistSH,

    merchantlevelmanageList,
    merchantlevelmanageEdit,

    merchantupgradeinfoList,
}



// WEBPACK FOOTER //
// ./src/service/APPService.js